import React from 'react';

const ConsGuardIcon: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <svg
            id="Layer_3"
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 124.94 152.07"
            className={className}
        >
            <path
                d="M62.47,8.45S44.48,29.44,5.5,32.44v46.96c0,11.64,3.3,23.07,9.74,32.77,8.37,12.61,23.02,27.75,47.23,34.21,24.21-6.46,38.86-21.6,47.23-34.21,6.44-9.7,9.74-21.13,9.74-32.77v-46.96c-38.98-3-56.97-23.99-56.97-23.99Z"
                fill="none"
                stroke="currentColor"
                strokeMiterlimit="10"
                strokeWidth="11"
            />
            <ellipse cx="39.55" cy="59.01" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="62.42" cy="59.01" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="85.3" cy="59.01" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="39.64" cy="79.62" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="62.51" cy="79.62" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="85.39" cy="79.62" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="40.43" cy="100.24" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="63.31" cy="100.24" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
            <ellipse cx="86.18" cy="100.24" rx="2.16" ry="2.15" fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="11" />
        </svg>
    );
};

export default ConsGuardIcon;
